/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // Find the element to be moved using its class name
 const elementToMove = document.querySelector('.announcement__wrapper--top');
 // Find the target container where the element will be moved to using its class name
 const targetContainer = document.querySelector('.header__wrapper');
 
 // Specify the index at which the element will be inserted into the target container (default is 0)
 const targetIndex = 0;


 // Append the element to be moved at the specified index as a child of the target container
 targetContainer.insertBefore(elementToMove, targetContainer.children[targetIndex]);
  
  if(meta.product)  {
    var product_type = meta.product.type;
    if (product_type == "Rings") {
      const list = document.getElementsByClassName(
        "selector-wrapper selector-wrapper--size"
      )[0];
      list.getElementsByClassName("radio__legend__option-name")[0].innerHTML =
        "Size (India)";
    }
}

  setTimeout(hideReviewWishlist, 3000);

  function hideReviewWishlist() {
      var style = document.createElement( 'style' );
      style.innerHTML = '.gw-wl-page-item-header {display:block !important;} .gw-wl-page-item__listing-avg-reviews-container { display: none; }';
      document.querySelector('.gw-wl-page-placeholder').shadowRoot.appendChild( style );
  }

 
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
